import React, { memo, useEffect, useState } from 'react';
// import '../css/medwikiDetailsV2.scss';
import { AiOutlineUserAdd } from '../../../components/icons';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import MedwikiChannelLoader from '../../../skeleton/medwiki/MedwikiDetailsV2/MedwikiChannelLoader';
import useRedirect from '../../../components/customHooks/useRedirect';
import { useDispatch } from 'react-redux';
import { useTracker } from '../../../TrackerFolder/TrackerComponent';
import { followSwitching } from '../../../Store/actions/channelActions';
import LazyImage from '../../../components/CustomLibraries/LazyImage';
import { EVENT } from '../../../TrackerFolder/constants/ActionType';
import { trackEvent } from '../../../TrackerFolder/actions';

const MedwikiChannel = ({ data = null, isLoading, gtmTagVariable = '' }) => {
  const { redirectTo } = useRedirect();
  const [disabled, setDisabled] = useState(true);
  const [btn, setBtnVal] = useState('');
  const disptach = useDispatch();
  const { trackActivityEvent } = useTracker();
  const click = () => {
    trackActivityEvent(EVENT, trackEvent('VIEW_DETAILS_CLICK'));
    redirectTo('ChannelProfile', data?.channel_id, data?.title);
  };
  const checkButtonByFollowedStatus = (followed_status) => {
    if (followed_status == 1) {
      setBtnVal('Access Requested');
      setDisabled(false);
    } else if (followed_status == 3) {
      setBtnVal('Unfollow');
    } else if (followed_status == 0) {
      if (data?.privacy_status == 1) {
        setBtnVal('Request Access');
      } else {
        setBtnVal('Follow');
      }
    }
  };
  useEffect(() => {
    if (data?.followed_status !== undefined) {
      checkButtonByFollowedStatus(data?.followed_status);
    }
  }, [data?.followed_status]);

  const followSwitch = () => {
    if (disabled == true) {
      disptach(
        followSwitching(data?.channel_id, (response) => {
          console.log('Switch', response.data);
          checkButtonByFollowedStatus(response.data);
        })
      );
    }
  };
  console.log('data?.followed_status', data?.followed_status, data);
  return (
    <>
      {data && isLoading == false ? (
        <div className="w-100 medwikiChannelBox overflow-hidden rounded-3 shadow text-center mb-5">
          <div className="medwikiChannelBoxIn d-flex justify-conntent-between">
            <div className="medwikiChannelPart d-flex justify-content-start align-items-center py-3 pe-20 ps-3">
              {data?.logo && (
                <div className="medwikiChannelPic position-relative overflow-hidden rounded-circle bg-white d-inline-flex justify-content-center align-items-center p-2">
                  <LazyImage
                    src={data?.logo}
                    alt="Medwiki Channel"
                    className={`mw-100 mh-100 w-auto h-auto ${gtmTagVariable}_channel`}
                    extraClass={
                      'd-flex justify-content-center align-items-center w-100 h-100 position-relative'
                    }
                    onClick={click}
                    logo
                  />
                </div>
              )}
              {data?.title && (
                <div className="medwikiChannelName ps-3 text-start">
                  <h4
                    className={`fs-4 fw-medium text-black line-clamp-2 ${gtmTagVariable}_channel`}
                    onClick={click}
                  >
                    {data?.title}
                  </h4>
                </div>
              )}
            </div>
            <div
              className="followBtn bg-secondary position-relative d-flex align-items-center justify-content-center pe-3 ps-3 "
              onClick={followSwitch}
            >
              <div className="followBtnIn z-1 position-relative d-flex align-items-center gap-1">
                <AiOutlineUserAdd
                  customClass={`fs-3 text-white  ${gtmTagVariable}_channel_follow_button_icon`}
                  gtmTagVariable={`${gtmTagVariable}_channel_follow_button`}
                />
                <span
                  className={`fs-4 fw-medium text-white d-block ${gtmTagVariable}_channel_follow_button`}
                  gtmTagVariable={`${gtmTagVariable}_channel_follow_button`}
                >
                  {btn}
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : isLoading ? (
        <MedwikiChannelLoader />
      ) : null}
    </>
  );
};

export default memo(MedwikiChannel);
